import { Editor, Range } from '@tiptap/core'
import React from 'react'

import CheckListIcon from '~icons/editor/checklist.svg'
import H1Icon from '~icons/editor/h1.svg'
import H2Icon from '~icons/editor/h2.svg'
import H3Icon from '~icons/editor/h3.svg'
import H4Icon from '~icons/editor/h4.svg'
import NumericListIcon from '~icons/editor/ol.svg'
import ParagraphIcon from '~icons/editor/p.svg'
import QuoteIcon from '~icons/editor/quote.svg'
import BulletListIcon from '~icons/editor/ul.svg'
// import GrammarIcon from '~icons/grammar.svg'
// import LanguageIcon from '~icons/language.svg'
// import LaunchBriefIcon from '~icons/launchBrief-md.svg'
// import WriteIcon from '~icons/write.svg'
import { isFunction } from '~lib/helpers'

export type SuggestionItem = {
  label: string
  icon: JSX.Element
  isVisible?: (editor: Editor) => boolean
  disabled?: boolean
  hint?: string
  command: (props: { editor: Editor; range: Range; props: SuggestionItem }) => void
}

export type SuggestionItemsOptions = {
  extraItems: SuggestionItem[]
}

const getSuggestionItems = (query: string, editor: Editor, options?: SuggestionItemsOptions): SuggestionItem[] => {
  return [
    {
      label: 'H1 Title',
      icon: <H1Icon />,
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).setNode('heading', { level: 1 }).run()
      },
    },
    {
      label: 'H2 Title',
      icon: <H2Icon />,
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).setNode('heading', { level: 2 }).run()
      },
    },
    {
      label: 'H3 Title',
      icon: <H3Icon />,
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).setNode('heading', { level: 3 }).run()
      },
    },
    {
      label: 'H4 Title',
      icon: <H4Icon />,
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).setNode('heading', { level: 4 }).run()
      },
    },
    {
      label: 'Paragraph',
      icon: <ParagraphIcon />,
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).setNode('paragraph').run()
      },
    },
    {
      label: 'Ordered list',
      icon: <NumericListIcon />,
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleOrderedList().run()
      },
    },
    {
      label: 'BulletList',
      icon: <BulletListIcon />,
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleBulletList().run()
      },
    },
    {
      label: 'Task List',
      icon: <CheckListIcon />,
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleTaskList().run()
      },
    },
    {
      label: 'Blockquote',
      icon: <QuoteIcon />,
      command: ({ editor, range }) => {
        editor.chain().focus().deleteRange(range).toggleBlockquote().run()
      },
    },
    ...options.extraItems,
  ].filter(
    (item) =>
      item.label.toLowerCase().startsWith(query.toLowerCase()) &&
      (!isFunction(item.isVisible) || item.isVisible(editor))
  )
}

export default getSuggestionItems
